export default __webpack_public_path__ + "static/media/javascript.fe5608b1.gif";